<template>
<div class="chapter">
<div class="inner_page">
<div class="contents" id="con01">
<h2 class="contentsHead" style="text-indent: 0%;"><span class="bold">Contents</span></h2>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryName" style="text-indent: 0%; margin-left: 3%;"><a href="#/9781466805798_fm01#fm01">List of Illustrations</a></p></div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryName" style="text-indent: 0%; margin-left: 3%;"><a href="#/9781466805798_fm02#fm02">Biographies</a></p></div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryName" style="text-indent: 0%; margin-left: 3%;"><a href="#/9781466805798_fm03#fm03">Chronology</a></p></div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryName1" style="text-indent: 0%; margin-left: 3%;"><a href="#/9781466805798_fm04#fm04">Tables of Genealogy</a></p></div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryName" style="text-indent: 0%; margin-left: 3%;"><a href="#/9781466805798_fm05#fm05">Introduction</a></p></div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryNumber" style="text-indent: 0%;"><a href="#/9781466805798_ch01#ch01">1. Marriages, Birth and Death</a></p></div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryNumber" style="text-indent: 0%;"><span href="#/9781466805798_ch02#ch02" title="Link target outside of Sample">2. Last Will and Testament</span></p></div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryNumber" style="text-indent: 0%;"><span href="#/9781466805798_ch03#ch03" title="Link target outside of Sample">3. A Second Josiah</span></p></div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryNumber" style="text-indent: 0%;"><span href="#/9781466805798_ch04#ch04" title="Link target outside of Sample">4. Milder Climates</span></p></div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryNumber" style="text-indent: 0%;"><span href="#/9781466805798_ch05#ch05" title="Link target outside of Sample">5. The Downfall of the Lord Admiral</span></p></div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryNumber" style="text-indent: 0%;"><span href="#/9781466805798_ch06#ch06" title="Link target outside of Sample">6. Commotion Time</span></p></div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryNumber" style="text-indent: 0%;"><span href="#/9781466805798_ch07#ch07" title="Link target outside of Sample">7. Coup d’Etat</span></p></div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryNumber" style="text-indent: 0%;"><span href="#/9781466805798_ch08#ch08" title="Link target outside of Sample">8. Uncertain Times</span></p></div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryNumber" style="text-indent: 0%;"><span href="#/9781466805798_ch09#ch09" title="Link target outside of Sample">9. Hidden Conspiracies</span></p></div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryNumber" style="text-indent: 0%;"><span href="#/9781466805798_ch10#ch10" title="Link target outside of Sample">10. The Destruction of the Duke</span></p></div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryNumber" style="text-indent: 0%;"><span href="#/9781466805798_ch11#ch11" title="Link target outside of Sample">11. An Emerging King</span></p></div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryNumber" style="text-indent: 0%;"><span href="#/9781466805798_ch12#ch12" title="Link target outside of Sample">12. Promise Unfulfilled</span></p></div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryNumber1" style="text-indent: 0%;"><span href="#/9781466805798_ch13#ch13" title="Link target outside of Sample">13. Nemesis</span></p></div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryName" style="text-indent: 0%; margin-left: 4%;"><span href="#/9781466805798_bm01#bm01" title="Link target outside of Sample">Select Bibliography</span></p></div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryName" style="text-indent: 0%; margin-left: 3%;"><span href="#/9781466805798_ack01#ack01" title="Link target outside of Sample">Acknowledgements</span></p></div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryName" style="text-indent: 0%; margin-left: 4%;"><span href="#/9781466805798_end01#end01" title="Link target outside of Sample">Notes</span></p></div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryName" style="text-indent: 0%; margin-left: 4%;"><span href="#/9781466805798_indx01#indx01" title="Link target outside of Sample">Index</span></p></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781466805798_con01.vue?0053040b